<template id="slidemenu">
  <div class="fixed z-50 block w-full bg-white border-b border-gray-300 menu xl:hidden">
    <div class="flex items-center justify-start w-1/2 my-2">
      <router-link to="/profile">
        <img @click="homeClicked" class="w-48 px-5 mr-16 lg:px-0" src="/storage/image/logo.png" alt />
      </router-link>
    </div>
    <div
      class="pointer"
      :class="['menu__burger', {'menu__burger--open': this.open}] "
      @click="toggleNav"
    >
      <span class="menu__burger__span"></span>
    </div>

    <nav
      class="fixed top-0 left-0 w-screen h-screen bg-white"
      :class="['menu__nav', {'menu__nav--open': this.open}]"
    >
      <div class="flex items-center justify-center w-full h-full py-4 menu-container">
        <ul class="mx-0 my-auto text-2xl menu-wrapper">
          <li @click="setActiveClass" class="py-2 font-bold text-left menu-item">
            <router-link to="/profile">
              <span @click="homeClicked">{{ $t('messages.general.home') }}</span>
            </router-link>
          </li>
          <li class="py-2 font-bold text-left cursor-pointer menu-item has-dropdown">
            <p class="flex items-center dropdown-trigger z-1" @click="toogleActiveClass">
              {{ $t('messages.general.my_activity') }}
              <span class="z-0 drop-arrow">&#x25BC;</span>
            </p>
            <ul class="cursor-auto sub-menu-wrapper">
              <li @click="setActiveClass" class="py-2 font-normal text-black menu-item">
                <router-link to="/visits">{{ $t('messages.general.visits_to_your_profile') }}</router-link>
              </li>
              <li @click="setActiveClass" class="py-2 font-normal text-black menu-item">
                <router-link to="/favorites">{{ $t('messages.general.favorites') }}</router-link>
              </li>
              <li @click="setActiveClass" class="py-2 font-normal text-black menu-item">
                <router-link
                  to="/reciprocal-favorites"
                >{{ $t('messages.general.reciprocal_favorites') }}</router-link>
              </li>
              <li @click="setActiveClass" class="py-2 font-normal text-black menu-item">
                <router-link to="/invitations">{{ $t('messages.general.invitations') }}</router-link>
              </li>
              <li @click="setActiveClass" class="py-2 font-normal text-black menu-item">
                <router-link to="/share">{{ $t('messages.general.tell_your_friends') }}</router-link>
              </li>
              <li @click="setActiveClass" class="py-2 font-normal text-black menu-item">
                <router-link to="/stories">{{ $t('messages.general.stories') }}</router-link>
              </li>
              <li @click="setActiveClass" class="py-2 font-normal text-black menu-item">
                <router-link to="/blocked-profile">{{ $t('messages.general.locked_profiles') }}</router-link>
              </li>
            </ul>
          </li>
          <li @click="setActiveClass" class="py-2 font-bold text-left menu-item">
            <router-link to="/search">{{ $t('messages.general.search') }}</router-link>
          </li>
          <li @click="openChat" class="py-2 font-bold text-left menu-item">
            <a class="flex">
              {{ $t('messages.general.messages') }}
              <span
                class="flex items-center justify-center w-6 h-6 ml-2 text-xs font-medium text-white bg-blue-500 rounded-full"
                v-if="messagesCount"
              >{{ messagesCount > 99 ? '+99' : messagesCount }}</span>
            </a>
          </li>
          <li @click="setActiveClass" class="py-2 font-bold text-left menu-item">
            <router-link to="/support">{{ $t('messages.general.support') }}</router-link>
          </li>
          <li @click="setActiveClass" class="py-2 font-bold text-left menu-item">
            <router-link to="/subscriptions">{{ $t('messages.general.subscription_title') }}</router-link>
          </li>
          <li class="py-2 font-bold text-left cursor-pointer menu-item has-dropdown">
            <p class="flex items-center dropdown-trigger z-1" @click="toogleActiveClass">
              {{ $t('messages.general.profile') }}
              <span class="z-0 drop-arrow">&#x25BC;</span>
            </p>
            <ul class="cursor-auto sub-menu-wrapper">
              <li @click="setActiveClass" class="py-2 font-normal text-black menu-item">
                <router-link to="/edit-profile">{{ $t('messages.general.edit_profile') }}</router-link>
              </li>
              <li @click="setActiveClass" class="py-2 font-normal text-black menu-item">
                <router-link :to="{name: 'profile-edit', params: { edit: 'yes', lang: locale }}">{{ $t('messages.profile_tabs.complete_profile') }}</router-link>
              </li>
              <li @click="setActiveClass" class="py-2 font-normal text-black menu-item">
                <router-link
                  to="/renewal-subscription"
                >{{ $t('messages.general.subscription_renewal') }}</router-link>
              </li>
              <li class="py-2 font-normal text-black menu-item">
                <a
                  class="cursor-pointer"
                  @click.prevent="handleLogout"
                >{{ $t('messages.general.logout') }}</a>
              </li>
            </ul>
          </li>

          <select
            name="language"
            :value="locale"
            v-model="language"
            @change="changeLocale"
            class="px-6 py-1 mr-2 text-xl font-semibold bg-gray-200 rounded appearance-none focus:outline-none md:py-2"
          >
            <option value="es">{{$t('messages.languages.spanish') }}</option>
            <option value="en">{{$t('messages.languages.english') }}</option>
          </select>
        </ul>
      </div>
    </nav>

    <transition name="modal">
      <div v-if="mobile">
        <div class="z-50 flex items-center justify-center w-full h-full px-2 overlay lg:px-0">
          <div class="w-full p-4 mx-auto my-0 bg-white rounded-lg modal md:w-1/2 xl:w-2/5 lg:p-6">
            <div class="container px-0 m-auto lg:px-10">
              <h1
                class="text-2xl font-bold text-center text-blue-500 uppercase lg:text-3xl"
              >{{ $t('messages.general.phone_comfirm.title') }}</h1>
              <p
                class="my-3 text-base font-semibold text-center lg:my-6"
              >{{ $t('messages.general.phone_comfirm.message') }}</p>
              <div class="w-full">
                <div class="w-full" v-if="!verify">
                  <div class="w-3/4 mx-auto">
                    <label class="font-bold tracking-wide">{{ $t('messages.verify.mobile_phone') }}</label>
                    <vue-tel-input
                      v-model="phone"
                      v-bind="phoneProps"
                      :dynamicPlaceholder="true"
                      v-validate="'required|unique_phone_mobile'"
                      :data-vv-as="$t('messages.step_one.phone')"
                      class="w-full border border-blue py-2"
                    ></vue-tel-input>
                    <ul>
                      <li
                        v-for="(error, index) in errors.collect('telephone')"
                        :key="index"
                        class="text-sm text-red-500 font-semibold mt-2 is-danger"
                      >{{ error }}</li>
                    </ul>
                  </div>
                  <div class="w-3/4 mx-auto">
                    <a
                      href="#"
                      @click.prevent="isSendingCode ? null : send()"
                      class="block text-center font-semibold tracking-wide bg-pink-500 text-white font-semibold rounded px-4 py-4 mt-4 hover:text-pink-500 hover:bg-white border hover:border-pink-500"
                    >
                      <template v-if="isSendingCode">
                        <spinner :size="25" />
                      </template>
                      <template v-else>{{ $t('messages.verify.confirm') }}</template>
                    </a>
                  </div>
                </div>
                <div v-else>
                  <div class="w-3/4 mx-auto">
                    <label class="font-bold tracking-wide">{{ $t('messages.verify.introduce_code') }}</label>
                    <input
                      class="h-10 block border-blue border w-full rounded pl-6 text-center"
                      type="number"
                      v-model="code"
                      name="code"
                      :placeholder="$t('messages.verify.example')"
                    />
                    <span class="text-red-500" v-if="error">{{ $t('messages.verify.incorrect_code') }} </span>
                    <div class="text-blue-800 cursor-pointer" v-if="error" @click.prevent="verify = false">{{ $t('messages.verify.change') }}</div>
                  </div>
                  <div class="w-3/4 mt-4 mx-auto">
                    <a
                      href="#"
                      @click.prevent="isSendingCode ? null : verifyCode()"
                      class="block text-center font-semibold tracking-wide bg-pink-500 text-white font-semibold rounded px-4 py-4 mt-4 hover:text-pink-500 hover:bg-white border hover:border-pink-500"
                    >
                      <template v-if="isSendingCode">
                        <spinner :size="25" />
                      </template>
                      <template v-else>{{ $t('messages.verify.confirm') }}</template></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Cookies from "js-cookie";
import bus from "@/bus";
import get from 'lodash/get';
import "vue-tel-input/dist/vue-tel-input.css";
import VueTelInput from "vue-tel-input";
import { verify } from "crypto";

export default {
  name: "SliderMenu",
  template: "#slidemenu",
  components: {
    VueTelInput
  },
  data: () => ({
    open: false,
    items: [{ name: "Home", to: "/" }],
    language: Cookies.get("locale") ? Cookies.get("locale") : "en",
    messagesCount: 0,
    mobile: false,
    phone: null,
    verify: false,
    code: null,
    error: false,
    isSendingCode: false,
    phoneProps: {
      defaultCountry: "",
      disabledFetchingCountry: false,
      disabled: false,
      disabledFormatting: false,
      placeholder: "7789 4567",
      required: false,
      enabledCountryCode: false,
      enabledFlags: true,
      preferredCountries: ["SV", "US"],
      onlyCountries: [],
      ignoredCountries: [],
      autocomplete: "on",
      name: "telephone",
      maxLen: 25,
      wrapperClasses: "",
      inputClasses: "",
      dropdownOptions: {
        disabledDialCode: false
      },
      inputOptions: {
        showDialCode: false
      },
      validCharactersOnly: true
    }
  }),
  created() {

    bus.$on("update-counter-mobile", count => {
      this.messagesCount = count;
    });
  },
  mounted() {
    if (this.$route.params.lang) {
      this.language = this.$route.params.lang;
      this.setLocale(this.$route.params.lang);
    }

    if (this.hasValidUser()) {
      if (!this.user.status) {
             this.forceLogout();
            this.$router.replace({ name: 'home' });
      }
      this.updateUserConnection({ user: this.user.id, active: true});
      if (this.user.pictures.length === 0 && this.user.subscription_status !== 'active') {
        this.$swal
          .fire({
            text: this.$t('messages.delete_photo.onLessQuantity.description'),
            confirmButtonText: this.$t('messages.delete_photo.onLessQuantity.accept')
          });
      }


      if (this.user.phone_validate) {

          this.phone = this.user.profile.phone_mobile;
          this.mobile = true;

      } else if (this.user.automatic_phone_validate && !this.user.profile.phone_validate) {

        const country_whitelist = ['AU','GB','CA', 'US'];
        const country_blacklist = ['UG','IN','NG', 'UA'];
        let created = new Date(this.user.profile.created_at);
        let today = new Date();
        let date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
        let time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        let dateTime = new Date(date+' '+time);

        let difTime = (dateTime-created) / (1000*60);

        if (difTime >= 2) {

            this.phone = this.user.profile.phone_mobile;
            this.mobile = true;

        } else{
          let timeOut=0;

          //country_whitelist.includes(this.user.profile.country.iso) ? timeOut = 2 : timeOut = 1;
          if (country_whitelist.includes(this.user.profile.country.iso)) {
            timeOut = 1;
            timeOut = (timeOut * 60) - (difTime * 60);
          } else if (country_blacklist.includes(this.user.profile.country.iso)) {
            timeOut = 0;
          } else {
            timeOut = 0.5;
            timeOut = (timeOut * 60) - (difTime * 60);
          }

          setTimeout(() => {
            this.phone = this.user.profile.phone_mobile;
            this.mobile = true;
          }, timeOut * 1000);

        }
      }

      Echo.private(`App.User.${ this.user.id }`)
        .notification(async ({ type }) => {
          if (type === 'App\\Notifications\\ProfileDeleted') {
            this.forceLogout();
            this.$router.replace({ name: 'home' });
          } else if (type === 'App\\Notifications\\ForceLogout') {
            this.forceLogout();
            this.$router.replace({ name: 'home' });
          } else if (type === 'App\\Notifications\\ForcePhoneVerify') {
            this.mobile = true;
          }else if(type === 'App\\Notifications\\ForceReload') {
            location.reload();
          } else {
            await this.fetchUser(true);
          }
        });
    }
  },
  computed: {
    ...mapState("locale", ["locale"]),
    ...mapState("auth", ["user"]),
  },
  methods: {
    ...mapActions("profiles", ["getCallerProfile", "setPaginationPage", "storeSearchParams"]),
    ...mapActions("stateChat", ["updateState", "updateCallState"]),
    ...mapActions("auth", ["fetchUser", "logout", 'forceLogout', 'updateChatAlert','updateUserConnection']),
    ...mapActions("locale", ["setLocale"]),
    homeClicked() {
      this.setPaginationPage(1);
      this.storeSearchParams({});
    },
    async send() {
      try {
        this.isSendingCode = true;
        this.error = false;
        await axios.post("/api/web/code/send", {
          number_phone: this.phone,
          type: "sms"
        });
        this.verify = true;
        this.isSendingCode = false;
      } catch (error) {
        this.isSendingCode = false;
        return error;
      }
    },
    async verifyCode() {
      try {
        this.isSendingCode = true;
        const { data } = await axios.post("/api/web/code/verify", {
          number_phone: this.phone,
          code: this.code
        });
        if (data.verified) {
          await this.fetchUser(true);
          this.mobile = false;
          this.isSendingCode = false;
          return;
        }
        this.error = true;
        this.isSendingCode = false;
      } catch (error) {
        this.isSendingCode = false;
        return error;
      }
    },
    hasValidUser() {
      return !!get(this.user, 'id', null);
    },
    changeLocale(e) {
      this.$router.push({ params: {
        lang: e.target.value
      }});

      this.setLocale(e.target.value);
    },
    async handleLogout() {
      try {
        await this.logout();
        this.$router.push({
          name: 'home'
        });
      } catch (error) {
        this.$router.push({
          name: 'home'
        });
      }
    },
    toggleNav() {
      this.open = !this.open;
      this.$emit("toggle", this.open);

      if (this.open) {
        document.body.style.overflow = "hidden";
      }

      document.body.style.overflow = "auto";
    },
    showDrop() {
      document.getElementById("myDropdown").classList.toggle("show_list");
    },
    toogleActiveClass(e) {
      const { target } = e;

      if (e.target.classList.contains("active")) {
        e.target.classList.remove("active");
        return;
      }

      Array.from(
        document.querySelectorAll(".has-dropdown .dropdown-trigger")
      ).forEach(item => item.classList.remove("active"));

      e.target.classList.add("active");
    },
    setActiveClass(e) {
      const { target } = e;
      const activeClass = "active-link";
      Array.from(
        document.querySelectorAll(".menu-item .active-link")
      ).forEach(item => item.classList.remove(activeClass));

      target.classList.add(activeClass);

      this.open = !this.open;
    },
    openChat(e) {
      if (this.user.profile.state_chat === 0) {
        this.isOpen = true;
      } else {
        this.isOpen = false

        this.$router.push({
          name: "chat",
          params: {
            random: Date.now(),
          }
        });
      }

      this.setActiveClass(e);
    }
  }
};
</script>
<style lang="scss">
.menu-container {
  .menu-item {
    &:hover,
    & .active-link {
      color: #1d42b1;
    }
  }

  .has-dropdown {
    .sub-menu-wrapper {
      max-height: 0;
      overflow: hidden;
      -webkit-transition: all 0.5s ease-in-out;
      -moz-transition: all 0.5s ease-in-out;
      -o-transition: all 0.5s ease-in-out;
      transition: all 0.5s ease-in-out;
    }

    .dropdown-trigger.active {
      color: #1d42b1;
    }
    .dropdown-trigger.active ~ .sub-menu-wrapper {
      max-height: 500px;
    }

    .drop-arrow {
      font-size: 0.6em;
      color: #1d42b1;
      padding-left: 1em;
    }
  }
}
.show_list {
  display: flex !important;
}
.dropdown-content {
  display: none;
}

.menu {
  $root: &;

  &__burger {
    $burger: #{$root}__burger;
    width: 40px;
    right: 20px;
    top: 25px;
    position: fixed;
    cursor: pointer;
    z-index: 200;

    &__span {
      position: absolute;
      height: 3px;
      width: inherit;
      background-color: #0669f9;
      transition: all 0.2s;
      &:before {
        @extend #{$burger}__span;
        content: "";
        top: -10px;
      }
      &:after {
        @extend #{$burger}__span;
        content: "";
        top: 10px;
      }
    }
    &--open {
      #{$burger}__span {
        background-color: transparent;
        &:before,
        &:after {
          background-color: #0669f9;
          transform-origin: 0 50%;
        }
        &:before {
          transform: translateX(7px) translateY(-5px) rotate(45deg);
        }
        &:after {
          transform: translateX(7px) translateY(3px) rotate(-45deg);
        }
      }
    }
  }
}

.menu__nav {
  transform: translateX(-100%);
  transition: all 0.3s;
  z-index: 100;
  &--open {
    display: inline-grid;
    overflow: scroll;
    transform: translateX(0);
  }
}
</style>
